import React, { useEffect, useState, useRef } from "react";
import CustomInput from "../components/CustomInput";
import ReactQuill from "react-quill";
import { useNavigate } from "react-router-dom";
import "react-quill/dist/quill.snow.css";
import { toast } from "react-toastify";
import * as yup from "yup";
import { useFormik } from "formik";
import axios from "axios";
import { base_url } from "../utils/baseUrl";

// Validation schema
const schema = yup.object().shape({
  name: yup.string().required("Name is Required"),
  description: yup.string().required("Description is Required"),
  slug: yup.string().required("Slug is Required"),
  category: yup.string().required("Category is Required"),
  author_name: yup.string().required("Author Name is Required"),
  tags: yup.string().required("Tags are Required"),
  is_published: yup.boolean().required("Published Status is Required"),
});

const AddBlog = () => {
  const inputRef = useRef(null);
  const [image, setImage] = useState(null); // Thumbnail image state
  const [categories, setCategories] = useState([]); // Categories state
  const navigate = useNavigate();

 
    const adminToken = localStorage.getItem("adminToken");
console.log("Admin Token:", adminToken);

 useEffect(() => {
    const adminToken = localStorage.getItem("adminToken");
    if (!adminToken) {
      navigate("/");
    }
  }, [navigate]);
  // Fetch categories from the backend
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get(`${base_url}/api/blogs/getBlogCategory`);
        setCategories(response.data.result); // Set the categories from the API response
      } catch (error) {
        console.error("Error fetching categories:", error);
        toast.error("Failed to load categories");
      }
    };
    fetchCategories();
  }, []);

  // Function to compress image if it's larger than 250KB
  const compressImage = async (file) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      const objectUrl = URL.createObjectURL(file);

      img.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        
        // Scale down the image to maintain aspect ratio
        const scaleFactor = Math.sqrt((250 * 1024) / file.size);
        canvas.width = img.width * scaleFactor;
        canvas.height = img.height * scaleFactor;

        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

        canvas.toBlob((blob) => {
          if (blob) {
            resolve(blob);
          } else {
            reject("Compression failed");
          }
        }, "image/jpeg", 0.7); // JPEG format with 70% quality
      };

      img.onerror = (err) => {
        reject(err);
      };

      img.src = objectUrl;
    });
  };

  // Trigger file input click
  const handleImageClick = () => {
    inputRef.current.click();
  };

  // Handle file change and update state
  const handleFileChange = async (e) => {
    const file = e.target.files[0]; // Only take the first selected image
    if (file) {
      // Check if image size exceeds 250KB, if so, compress it
      if (file.size > 250 * 1024) {
        const compressedImage = await compressImage(file);
        setImage({
          file: compressedImage,
          url: URL.createObjectURL(compressedImage),
        });
      } else {
        setImage({
          file,
          url: URL.createObjectURL(file),
        });
      }
    }
  };

  // Remove image from state
  const handleImageRemove = () => {
    setImage(null); // Remove the image
  };

  const formik = useFormik({
    initialValues: {
      name: "",  // Blog title
      description: "",  // Blog description
       slug: "",
      category: "",  // Category selection
      author_name: "",  // Author name
      tags: "",  // Tags
      is_published: false,  // Published status
    },
    validationSchema: schema,
    onSubmit: async (values) => {
      
      if (!image) {
    toast.error("Thumbnail image is required");
    return;
  }

  const formData = new FormData();
      
      // Append image if it exists
      if (image) {
        formData.append("thumbnail_url", image.file); // Appending thumbnail image
      }
  
      // Append the form values to FormData
      formData.append("name", values.name);  // Blog title
      formData.append("slug", values.slug || "default-slug");  // Default slug if not provided
      formData.append("description", values.description);  // Blog description
      formData.append("category", values.category);  // Blog category ID
      formData.append("author_name", values.author_name);  // Author name
      formData.append("tags", values.tags);  // Tags
      formData.append("is_published", values.is_published);  // Publication status
  
      try {
        const response = await axios.post(`${base_url}/api/blogs/createBlog`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",  // Ensure content type for file upload
          },
        });
        toast.success("Blog Added Successfully!");
        window.location.href = `https://gulabidecor.com/blog/${values.slug}`;  // Redirect to the blogs page after success
      } catch (error) {
        console.error("Error adding blog:", error);
        toast.error("Something Went Wrong!");
      }
    },
  });

  return (
    <div>
      <h3 className="mb-4 title">Add Blog</h3>
      <form onSubmit={formik.handleSubmit} className="d-flex gap-3 flex-column">
        {/* Blog Name */}
        <CustomInput
          type="text"
          label="Enter Blog Title"
          name="name"
          onChng={formik.handleChange("name")}
          onBlr={formik.handleBlur("name")}
          val={formik.values.name}
        />
        <div className="error">{formik.touched.name && formik.errors.name}</div>

        {/* Slug */}
        <CustomInput
          type="text"
          label="Enter Blog Slug"
          name="slug"
          onChng={formik.handleChange("slug")}
          onBlr={formik.handleBlur("slug")}
          val={formik.values.slug}
        />
        <div className="error">{formik.touched.slug && formik.errors.slug}</div>

        {/* Blog Description */}
        <ReactQuill
          theme="snow"
          value={formik.values.description}
          onChange={(content) => formik.setFieldValue("description", content)}
        />
        <div className="error">
          {formik.touched.description && formik.errors.description}
        </div>

        {/* Category Selection */}
        <label>Select Category</label>
        <select
          className="form-control"
          name="category"
          value={formik.values.category}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        >
          <option value="">Select Category</option>
          {categories.map((category) => (
            <option key={category.category_id} value={category.category_id}>
              {category.name}
            </option>
          ))}
        </select>
        <div className="error">{formik.touched.category && formik.errors.category}</div>

        {/* Author Name */}
        <CustomInput
          type="text"
          label="Author Name"
          name="author_name"
          onChng={formik.handleChange("author_name")}
          onBlr={formik.handleBlur("author_name")}
          val={formik.values.author_name}
        />
        <div className="error">{formik.touched.author_name && formik.errors.author_name}</div>

        {/* Tags */}
        <CustomInput
          type="text"
          label="Tags (comma separated)"
          name="tags"
          onChng={formik.handleChange("tags")}
          onBlr={formik.handleBlur("tags")}
          val={formik.values.tags}
        />
        <div className="error">{formik.touched.tags && formik.errors.tags}</div>

        {/* Published Status */}
        <label>Publish Status</label>
        <select
          className="form-control"
          name="is_published"
          value={formik.values.is_published}
          onChange={formik.handleChange} 
          onBlur={formik.handleBlur}
        >
          <option value={true}>Published</option>
          <option value={false}>Draft</option>
        </select>
        <div className="error">{formik.touched.is_published && formik.errors.is_published}</div>

        {/* Image Upload Section */}
        <div className="d-flex flex-wrap">
          {image && (
            <div key={0} className="position-relative m-2">
              <img src={image.url} alt="Thumbnail" className="img-fluid" style={{ width: '100px', height: "100px" }} />
              <button
                type="button"
                className="btn btn-danger position-absolute top-0 end-0"
                onClick={handleImageRemove}
              >
                X
              </button>
            </div>
          )}
          <div>
            <button type="button" className="btn btn-secondary" onClick={handleImageClick}>
              Upload Thumbnail
            </button>
            <input
              ref={inputRef}
              type="file"
              accept="image/*"
              hidden
              onChange={handleFileChange}
            />
          </div>
        </div>

        {/* Submit Button */}
        <button type="submit" className="btn btn-success">
          Add Blog
        </button>
      </form>
    </div>
  );
};

export default AddBlog;
